import { render, staticRenderFns } from "./RequestActualizationDialog.vue?vue&type=template&id=4bf03b28&"
import script from "./RequestActualizationDialog.vue?vue&type=script&lang=js&"
export * from "./RequestActualizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QTable,QTr,QTh,QTd,QCheckbox,QTooltip,QSelect,QBtn,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QTable,QTr,QTh,QTd,QCheckbox,QTooltip,QSelect,QBtn,QSeparator,QCardActions}, component.options.components || {})
